import { render, staticRenderFns } from "./ModalTranslate.vue?vue&type=template&id=12cf3204&"
import script from "./ModalTranslate.vue?vue&type=script&lang=js&"
export * from "./ModalTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports